<template>
  <div class="item-box" @click="onClickItemBox">
    <a :href="linkUrl">
      <div class="item-card">
        <div class="item-card-icon">
          <img v-lazy="imageUrl" />
        </div>
        <div class="item-card-info">
          <div class="item-card__brand-name">
            {{ brandName }}
          </div>
          <div class="item-card__item-name">
            {{ itemName }}
          </div>
          <div class="item-card__item-prices">
            <span class="item-card__item-price">{{ itemPrice }}</span>
            <span v-if="isIncludingTax" class="item-card__item-tax">税込</span>
            <span v-if="hasMultipleItemSkus" class="item-card__item-skus">
              〜
            </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemPrice: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    hasMultipleItemSkus: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClickItemBox() {
      this.$emit('click-item-box')
    }
  }
}
</script>
